import { render, staticRenderFns } from "./form21.vue?vue&type=template&id=835c7862&scoped=true&"
import script from "./form21.vue?vue&type=script&lang=js&"
export * from "./form21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835c7862",
  null
  
)

export default component.exports